export const GET_EQUIPMENT_AND_FACILITIES_POLICIES = 'GET_EQUIPMENT_AND_FACILITIES_POLICIES';
